import React, { useState } from 'react';
import { apiClient } from '../../api/client';
import Spinner from '../Spinner';
import './Login.css';

interface LoginProps {
  onLoginSuccess: (token: string) => void;
  onNavigateToRegister?: () => void;
}

const Login: React.FC<LoginProps> = ({ onLoginSuccess, onNavigateToRegister }) => {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [showPassword, setShowPassword] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const [isLoading, setIsLoading] = useState(false);

  React.useEffect(() => {
    document.title = 'AVM Analytics - Авторизация';
  }, []);

  const handleSubmit = async (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    setError(null);
    setIsLoading(true);

    try {
      const response = await apiClient.login(username, password);
      onLoginSuccess(response.access_token);
    } catch (err: any) {
      if (err.response && err.response.data && err.response.data.detail) {
        setError(err.response.data.detail);
      } else {
        setError('Произошла неизвестная ошибка. Попробуйте снова.');
      }
      setIsLoading(false);
    }
  };

  return (
    <div className="auth-page auth-page-login">
      <div className="auth-shell">
        <section className="auth-panel" aria-label="Форма входа">
          <span className="auth-panel-kicker">AVM Analytics</span>
          <h1 className="auth-panel-title">Вход в систему</h1>
          <p className="auth-panel-subtitle">
            Рабочее пространство аналитики и мониторинга.
          </p>

          {onNavigateToRegister && (
            <div className="auth-toggle" role="tablist" aria-label="Переключение формы доступа">
              <button
                className="auth-toggle-btn active"
                type="button"
                role="tab"
                aria-selected="true"
              >
                Вход
              </button>
              <button
                className="auth-toggle-btn"
                type="button"
                role="tab"
                aria-selected="false"
                onClick={() => onNavigateToRegister()}
              >
                Регистрация
              </button>
            </div>
          )}

          <form onSubmit={handleSubmit} className="auth-form">
            <div className="form-group">
              <label className="form-label" htmlFor="username">
                Имя пользователя
              </label>
              <div className="input-wrapper">
                <input
                  id="username"
                  type="text"
                  value={username}
                  onChange={(e) => setUsername(e.target.value)}
                  className="form-input"
                  placeholder="Введите логин"
                  required
                  autoComplete="username"
                />
              </div>
            </div>

            <div className="form-group">
              <div className="form-label-row">
                <label className="form-label" htmlFor="password">
                  Пароль
                </label>
                <button
                  type="button"
                  className="password-hint"
                  onClick={() => setShowPassword(!showPassword)}
                  aria-label={showPassword ? 'Скрыть пароль' : 'Показать пароль'}
                >
                  {showPassword ? 'Скрыть пароль' : 'Показать пароль'}
                </button>
              </div>
              <div className="input-wrapper">
                <input
                  id="password"
                  type={showPassword ? 'text' : 'password'}
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  className="form-input"
                  placeholder="Введите пароль"
                  required
                  autoComplete="current-password"
                />
              </div>
            </div>

            {error && (
              <div className="error-message" role="alert">
                {error}
              </div>
            )}

            <button type="submit" className="btn-primary" disabled={isLoading}>
              {isLoading ? <Spinner mini /> : 'Войти'}
            </button>
          </form>

          {onNavigateToRegister && (
            <div className="auth-footer">
              <span>Нет аккаунта?</span>
              <button
                type="button"
                className="auth-footer-link"
                onClick={() => onNavigateToRegister()}
              >
                Создать аккаунт
              </button>
            </div>
          )}
        </section>
      </div>
    </div>
  );
};

export default Login;
